import { planStateIds } from "./planStateIds";
import { planRoleGroups } from "./planRoles";

/**
 * BPMN-переходы PlanDocument (статус на документе, не на строке Plan).
 * Created(1) → InProgressNce(5) → OnSlaApproval(7) ⇄ InProgressNce(5)
 * OnSlaApproval(7) → OnApproval(13) → Approved(15) [ЭЦП]
 */
export const planWorkflowTransitions = [
  [planStateIds.created, planStateIds.inProgressNce],
  [planStateIds.inProgressNce, planStateIds.onSlaApproval],
  [planStateIds.onSlaApproval, planStateIds.inProgressNce],
  [planStateIds.onSlaApproval, planStateIds.onApproval],
  [planStateIds.onApproval, planStateIds.approved],
];

const canAnyRole = (...roles) => ({
  anyOf: roles.flat().filter(Boolean),
});

/**
 * UI-действия workflow по stateId документа.
 */
export const planWorkflowActionsByState = {
  [planStateIds.created]: [
    {
      key: "send_to_nce",
      title: "Отправить в НЦЭ",
      transition: [planStateIds.created, planStateIds.inProgressNce],
      roles: canAnyRole(...planRoleGroups.planning),
      confirm: {
        title: "Отправка в НЦЭ",
        message: "Отправить план в НЦЭ? Статус станет «В работе НЦЭ».",
      },
      needsComment: false,
    },
  ],
  [planStateIds.inProgressNce]: [
    {
      key: "send_for_sla",
      title: "Отправить на согласование",
      transition: [planStateIds.inProgressNce, planStateIds.onSlaApproval],
      roles: canAnyRole(...planRoleGroups.performer, ...planRoleGroups.planning),
      confirm: {
        title: "Отправка на согласование",
        message: "Отправить план на согласование СЛА?",
      },
      needsComment: false,
      ensurePlanServices: true,
    },
  ],
  [planStateIds.onSlaApproval]: [
    {
      key: "approve_sla",
      title: "Согласовать",
      transition: [planStateIds.onSlaApproval, planStateIds.onApproval],
      roles: canAnyRole(...planRoleGroups.sla),
      confirm: {
        title: "Согласование",
        message: "Согласовать план и отправить на утверждение директору?",
      },
      needsComment: false,
    },
    {
      key: "return_to_nce",
      title: "Вернуть в НЦЭ",
      transition: [planStateIds.onSlaApproval, planStateIds.inProgressNce],
      roles: canAnyRole(...planRoleGroups.sla),
      confirm: {
        title: "Возврат в НЦЭ",
        message: "Вернуть план в работу НЦЭ?",
      },
      needsComment: true,
    },
  ],
  [planStateIds.onApproval]: [
    {
      key: "sign_ecp",
      title: "Подписать ЭЦП",
      transition: [planStateIds.onApproval, planStateIds.approved],
      roles: canAnyRole(...planRoleGroups.director),
      confirm: {
        title: "Утверждение с ЭЦП",
        message:
          "Будет запрошена подпись через NCALayer (ключ PKCS12). Продолжить?",
      },
      needsComment: false,
      requiresEcpSign: true,
    },
  ],
};

export const getPlanWorkflowActionsForState = (stateId) => {
  const id = Number(stateId);
  if (!Number.isFinite(id)) return [];
  return planWorkflowActionsByState[id] || [];
};
